/**
 * Abstração de Armazenamento Seguro
 * Utiliza @capacitor/preferences para persistência no dispositivo Android.
 */

import { Preferences } from '@capacitor/preferences';

export const storage = {
  getItem: async (key: string): Promise<string | null> => {
    const { value } = await Preferences.get({ key });
    return value;
  },

  setItem: async (key: string, value: string): Promise<void> => {
    await Preferences.set({ key, value });
  },

  removeItem: async (key: string): Promise<void> => {
    await Preferences.remove({ key });
  },

  clear: async (): Promise<void> => {
    await Preferences.clear();
  }
};

